var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRate2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M42 21c0 11.598-9.402 21-21 21S0 32.598 0 21 9.402 0 21 0s21 9.402 21 21z",
    fill: props.fill
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.594 16.281c0 1.812-1.029 3.282-2.297 3.282-1.269 0-2.297-1.47-2.297-3.282S14.028 13 15.297 13c1.268 0 2.297 1.47 2.297 3.281zM29.406 16.281c0 1.812-1.028 3.282-2.297 3.282-1.268 0-2.297-1.47-2.297-3.282S25.841 13 27.11 13c1.269 0 2.297 1.47 2.297 3.281zM13 29.188c0-.716.44-1.357 1.117-1.589C15.824 27.015 19.135 26 21.5 26s5.676 1.015 7.383 1.6A1.666 1.666 0 0130 29.187c0 1.29-1.374 2.156-2.578 1.693-1.73-.666-4.03-1.381-5.922-1.381-1.892 0-4.192.715-5.922 1.38-1.204.464-2.578-.402-2.578-1.692z",
    fill: "#111827"
  })));
}
export default SvgRate2;